export const SET_USER = "setUser";
export const SET_CORPORATIONS = "setCorporations";
export const NEW_CORPORATION = "newCorporation";
export const UPDATE_CORPORATION = "updateCorporation";
export const DELETE_CORPORATION = "deleteCorporation";
export const SET_COMMUNITIES = "setCommunities";
export const NEW_COMMUNITY = "newCommunity";
export const UPDATE_COMMUNITY = "updateCommunity";
export const DELETE_COMMUNITY = "deleteCommunity";

export const SET_USERS = "setUsers";
export const NEW_USER = "newUser";
export const UPDATE_USER = "updateUser";
export const REMOVE_USER = "removeUser";

export const SET_SIZES = "setSizes";
export const SET_DIGITAL_FILES = "setDigitalFiles";

export const SET_ORDERS = "setPendingOrders";
export const UPDATE_PENDING_ORDER = "updatePendingOrder";
export const REMOVE_PENDING_ORDER = "removePendingOrder";
export const SET_ORDER_STATUSES = "setOrderStatuses";

export const UPDATE_AUTH_USER = "updateAuthUser";
export const SET_NOTIFICATIONS = "setNotifications";
export const MARK_NOTIFICATION_AS_READ = "markNotificationAsRead";
export const CHANGE_SUSPENSION_STATUS = "updateSuspensionStatus";
export const SET_CART = "setCart";
export const SET_CART_TAX = "setCartTax";
export const SET_LOADING_CART_TAX = "setLoadingCartTax";
export const SET_CURRENT_CALENDAR_MONTH = "setCurrentCalendarMonth";
export const SET_CURRENT_COMMUNITY = "setCurrentCommunity";
export const SET_CURRENT_CORPORATION = "setCurrentCorporation";
export const SET_DISCOUNTS = "setDiscounts";
export const SET_PRESET_DATA_FETCHED = "setPresetDataFetched";
export const SET_CURRENT_ORDER = "setCurrentOrder";

export const SET_PRICES = "setPrices";

export const SET_STATES = "setStates";

export const AGREED_POLICY = "agreedPolicy";

export const SET_CSRF = "setCsrf";

export const SET_COUPON = "setCoupon";
